import { render, staticRenderFns } from "./ContactsForm.vue?vue&type=template&id=440d2402&scoped=true&"
import script from "./ContactsForm.vue?vue&type=script&lang=js&"
export * from "./ContactsForm.vue?vue&type=script&lang=js&"
import style0 from "./ContactsForm.vue?vue&type=style&index=0&id=440d2402&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440d2402",
  null
  
)

export default component.exports